// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-pages__Loading__container__1tRbO {\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin-top: 15rem;\n}\n\n.auth-pages__Loading__container__1tRbO div {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n\n.auth-pages__Loading__card__3Gr9h {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0.3rem 0.5rem 0.7rem 0 rgba(81, 101, 107, 0.25);\n  font-size: 2.5rem;\n  font-weight: 200;\n  height: 18rem;\n  padding: 4.4rem 5.9rem;\n  text-align: center;\n  width: 30rem;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "auth-pages__Loading__container__1tRbO",
	"card": "auth-pages__Loading__card__3Gr9h"
};
module.exports = exports;
